import React, { useState } from 'react'
import { Button, Modal, notification, AutoComplete, Input } from "antd"
import { markSewingRepair } from '../../../../services/api/3dApi'

function SewingRepairModal(props) {
    const [loading, setLoading] = useState(false)
    const [repairType, setRepairType] = useState('')
    const [error, setError] = useState('')
    const { isOpen, onClose, inputValue, itemId, reset } = props

    const handleChangeError = (value) => {
        setRepairType(value)
    }

    const onCloseModal = () => {
        setRepairType('')
        setError('')
        onClose()
    }

    const onSewingRepair = async () => {
        setLoading(true)
        try {
            const payload = {
                type: repairType,
            }
            const { data: res } = await markSewingRepair(itemId, payload)
            const { success, error: message } = res
            if (success) {
                notification.success({
                    message: 'Đánh dấu sửa may thành công',
                    description: `Bạn đã đánh sửa may cho item ${inputValue} thành công`,
                })
                onCloseModal()
                reset()
            } else {
                notification.error({
                    message: `Đánh dấu sửa may item ${inputValue}  không thành công`,
                    description: message,
                })
            }
        } catch (error) {
            notification.error({
                message: 'Đánh dấu sửa may không thành công',
                description: error,
            })
        } finally{
            setLoading(false)
        }
    }

    const options = [
        'Lỗi đường may',
        'Sai kích thước',
        'Đối xứng chi tiết',
        'Không khớp hình',
        'Lỗi mác',
        'Thiếu, nhầm chi tiết',
        'Thiếu đường may',
        'Bục rách',
        'Lỗi lót',
        'Lỗi chân kim',
        'Lỗi khóa',
        'Lệch họng cổ',
    ]
    const { TextArea } = Input;

    return (
        <div className='SewingRepairModal'>
            <Modal
                visible={isOpen}
                title={(
                    <div className='d-flex justify-content-between'>
                        <div>Đánh dấu item cần sửa may</div>
                        <div className='mx-3'>{inputValue}</div>
                    </div>
                )}
                onOk={onSewingRepair}
                onCancel={onCloseModal}
                className='MarkItemErrorModal MarkItemModalQCComplete'
                footer={[
                    <Button key="back" onClick={onCloseModal}>
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="danger"
                        loading={loading}
                        style={{ background: '#ffc107', borderColor: '#ffc107' }}
                        onClick={onSewingRepair}
                    >
                        Đánh dấu sửa may
                    </Button>
                ]}
            >
                <div className="Content">
                    <div className="ErrorStyle">
                        <label htmlFor="error_type" className="Error">Lỗi:</label>
                        <AutoComplete
                            options={options}
                            dataSource={options}
                            filterOption={(inputValue, option) =>
                                option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                            onChange={handleChangeError}
                            allowClear
                            className='w-100'
                        >
                            <TextArea
                                placeholder="Nhập lỗi"
                                style={{ height: 100 }}
                            />
                        </AutoComplete>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default SewingRepairModal